import getGoalList from "./getGoals";
import pauseAllGoals from "./pauseAllGoals";
import syncGoalServices from "./syncGoalServices";

const goalsServices = {
    getGoalList,
    syncGoalServices,
    pauseAllGoals
}
export default goalsServices;